import { AccountClosureGridComponent } from './app/accountmaster/account-closure-grid/account-closure-grid.component';
import { AccountClosureComponent } from './app/accountmaster/account-closure/account-closure.component';
import { Routes } from '@angular/router'
import { AppComponent } from './app/app.component';
import { AgentCreationGridComponent } from './app/masters/agent-creation-grid/agent-creation-grid.component';

import { AgentCreationsComponent } from './app/masters/agent-creations/agent-creations.component';
import { AreaCreationGridComponent } from './app/masters/area-creation-grid/area-creation-grid.component';
import { AreaCreationsComponent } from './app/masters/area-creations/area-creations.component';
import { BankcreationComponent } from './app/masters/bankcreation/bankcreation.component';
import { BankcreationGridComponent } from './app/masters/bankcreation-grid/bankcreation-grid.component';
import { CastemastercreationComponent } from './app/masters/castemastercreation/castemastercreation.component';
import { CastemastercreationGridComponent } from './app/masters/castemastercreation-grid/castemastercreation-grid.component';
import { CustomerCreationComponent } from './app/masters/customer-creation/customer-creation.component';
import { CustomerCreationGridComponent } from './app/masters/customer-creation-grid/customer-creation-grid.component';
import { CustomerRiskAnalysisComponent } from './app/masters/customer-risk-analysis/customer-risk-analysis.component';
import { CustomerRiskAnalysisGridComponent } from './app/masters/customer-risk-analysis-grid/customer-risk-analysis-grid.component';
import { LedgerAccountComponent } from './app/masters/ledger-account/ledger-account.component';
import { LedgerAccountGridComponent } from './app/masters/ledger-account-grid/ledger-account-grid.component';
import { DepositRenewalGridComponent } from './app/accountmaster/deposit-renewal-grid/deposit-renewal-grid.component';
import { GsGaCreationGridComponent } from './app/accountmaster/gs-ga-creation-grid/gs-ga-creation-grid.component';
import { InactiveDormandGridComponent } from './app/accountmaster/inactive-dormand-grid/inactive-dormand-grid.component';
import { InstructionEntryGridComponent } from './app/accountmaster/instruction-entry-grid/instruction-entry-grid.component';
import { LoanApplicationGridComponent } from './app/accountmaster/loan-application-grid/loan-application-grid.component';
import { LoanSanctionGridComponent } from './app/accountmaster/loan-sanction-grid/loan-sanction-grid.component';
import { MemberCreationGridComponent } from './app/accountmaster/member-creation-grid/member-creation-grid.component';
import { NewDepositGridComponent } from './app/accountmaster/new-deposit-grid/new-deposit-grid.component';
import { PigmyCreationGridComponent } from './app/accountmaster/pigmy-creation-grid/pigmy-creation-grid.component';
import { SbAccountGridComponent } from './app/accountmaster/sb-account-grid/sb-account-grid.component';
import { DepositRenewalComponent } from './app/accountmaster/deposit-renewal/deposit-renewal.component';
import { GsGaCreationComponent } from './app/accountmaster/gs-ga-creation/gs-ga-creation.component';
import { InactiveDormandComponent } from './app/accountmaster/inactive-dormand/inactive-dormand.component';
import { InstructionEntryComponent } from './app/accountmaster/instruction-entry/instruction-entry.component';
import { LoanApplicationComponent } from './app/accountmaster/loan-application/loan-application.component';
import { LoanSanctionComponent } from './app/accountmaster/loan-sanction/loan-sanction.component';
import { MemberCreationComponent } from './app/accountmaster/member-creation/member-creation.component';
import { NewDepositComponent } from './app/accountmaster/new-deposit/new-deposit.component';
import { PigmyCreationComponent } from './app/accountmaster/pigmy-creation/pigmy-creation.component';
import { SbAccountComponent } from './app/accountmaster/sb-account/sb-account.component';

// var data = localStorage.getItem("accessToken");
// var defaultPage;
// if(data) defaultPage = "/home"; else defaultPage = "/login";

export const appRoutes: Routes = [ 

        {
            path:'agentcreationlist',component:AgentCreationGridComponent
        },
        {
            path:'agentcreate',component:AgentCreationsComponent
        },
        {
            path:'areacreationlist',component:AreaCreationGridComponent
        },
        {
            path:'areacreationform',component:AreaCreationsComponent
        },
       
       
        {
            path:'areacreationform/:ACODE/:mode',component:AreaCreationsComponent
        },


        {
            path:'bankcreation',component:BankcreationComponent
        },
        {
            path:'bankcreationlist',component:BankcreationGridComponent
        },
        {
            path:'castemaster',component:CastemastercreationComponent
        },
        {
            path:'castemasterlist',component:CastemastercreationGridComponent
        },
        {
            path:'customercreation',component:CustomerCreationComponent
        },
        {
            path:'customercreationlist',component:CustomerCreationGridComponent
        },
        {
            path:'customerriskanalysis',component:CustomerRiskAnalysisComponent
        },
        {
            path:'customerriskanalysislist',component:CustomerRiskAnalysisGridComponent
        },
        {
            path:'ledgeraccount',component:LedgerAccountComponent
        },
        {
            path:'ledgeraccountlist',component:LedgerAccountGridComponent
        },



        {
            path:'accountclosure',component:AccountClosureComponent
        },
        {
            path:'accountclosurelist',component:AccountClosureGridComponent
        },
        {
            path:'depositrenewal',component:DepositRenewalComponent
        },
        {
            path:'depositrenewallist',component:DepositRenewalGridComponent
        },
        {
            path:'gsgacreation',component:GsGaCreationComponent
        },
        {
            path:'gsgacreationlist',component:GsGaCreationGridComponent
        },
        {
            path:'inactivedormand',component:InactiveDormandComponent
        },
        {
            path:'inactivedormandlist',component:InactiveDormandGridComponent
        },
        {
            path:'instructionentry',component:InstructionEntryComponent
        },
        {
            path:'instructionentrylist',component:InstructionEntryGridComponent
        },
        {
            path:'loanapplication',component:LoanApplicationComponent
        },
        {
            path:'loanapplicationlist',component:LoanApplicationGridComponent
        },
        {
            path:'loansanction',component:LoanSanctionComponent
        },
        {
            path:'loansanctionlist',component:LoanSanctionGridComponent
        },
        {
            path:'membercreation',component:MemberCreationComponent
        },
        {
            path:'membercreationlist',component:MemberCreationGridComponent
        },
        {
            path:'newdeposit',component:NewDepositComponent
        },
        {
            path:'newdepositlist',component:NewDepositGridComponent
        },
        {
            path:'pigmycreation',component:PigmyCreationComponent
        },
        {
            path:'pigmycreationlist',component:PigmyCreationGridComponent
        },
        {
            path:'sbaccount',component:SbAccountComponent
        },
        {
            path:'sbaccountlist',component:SbAccountGridComponent
        },
        
    { path : '', redirectTo:'/agentcreationlist', pathMatch : 'full'}
];


// WEBPACK FOOTER //
// ./src/route.ts